import {
    AdminJobCvRejectionReason,
} from '../../common/admin_job_cv_rejection_reason.enum';
import { API_METHODS } from './api.enums';
import { apiAction } from './utils.actions';

export type CreateAdminAiMatchRejectionBody = {
    jobId: number;
    cvId: number;
    reasonCode: AdminJobCvRejectionReason;
};

export type AdminAiMatchRejectionResponse = CreateAdminAiMatchRejectionBody & {
    id: number;
    createdAt: string;
    created: boolean;
};

export type RemoveAdminAiMatchRejectionResponse = {
    removed: boolean;
};

export const createAdminAiMatchRejection = (
    payload: CreateAdminAiMatchRejectionBody,
) => apiAction<AdminAiMatchRejectionResponse>({
    url: '/api/admin/ai-match-rejections',
    method: API_METHODS.POST,
    payload,
    backdrop: false,
});

export const removeAdminAiMatchRejection = (
    params: { jobId: number; cvId: number },
) => apiAction<RemoveAdminAiMatchRejectionResponse>({
    url: `/api/admin/ai-match-rejections/${params.jobId}/${params.cvId}`,
    method: API_METHODS.DELETE,
    backdrop: false,
});
